import { defineMessages } from "react-intl";

export default defineMessages({
  title: {
    id: "app.containers.Results.title",
    defaultMessage: "Reports: Results",
  },
  byDiscipline: {
    id: "app.containers.Results.byDiscipline",
    defaultMessage: "By {label}",
  },
  byStudent: {
    id: "app.containers.Results.byStudent",
    defaultMessage: "By Student",
  },
  details: {
    id: "app.containers.Results.details",
    defaultMessage: "Details",
  },
  detailsReportTitle: {
    id: "app.containers.Results.details.title",
    defaultMessage: "Learning Assessment Report",
  },
  detailsReportSchool: {
    id: "app.containers.Results.details.school",
    defaultMessage: "School",
  },
  detailsReportSchoolNameLabel: {
    id: "app.containers.Results.details.detailsReportSchoolNameLabel",
    defaultMessage: "Course report",
  },
  reportsLabelUsername: {
    id: "app.containers.Results.reports.label.username",
    defaultMessage: "Username",
  },
  reportsLabelGradeScaled: {
    id: "app.containers.Results.reports.label.gradeScaled",
    defaultMessage: "Score",
  },
  reportsLabelGrade: {
    id: "app.containers.Results.reports.label.grade",
    defaultMessage: "Grade",
  },
  reportsLabelLevel: {
    id: "app.containers.Results.reports.label.level",
    defaultMessage: "Level",
  },
  reportsLabelHits: {
    id: "app.containers.Results.reports.label.hits",
    defaultMessage: "Hits",
  },
  reportsLabelErrors: {
    id: "app.containers.Results.reports.label.errors",
    defaultMessage: "Errors",
  },
  reportsLabelOmitted: {
    id: "app.containers.Results.reports.label.omitted",
    defaultMessage: "Omitted",
  },
  reportsLabelNotQualified: {
    id: "app.containers.Results.reports.label.notQualified",
    defaultMessage: "Not qualified",
  },
  legendLabelQuestionHit: {
    id: "app.containers.Results.legendLabelQuestionHit",
    // defaultMessage: "Verde (preguntas buenas)",
    defaultMessage: "Green (questions hits)",
  },
  legendLabelQuestionError: {
    id: "app.containers.Results.legendLabelQuestionError",
    // defaultMessage: "Azul (preguntas malas)",
    defaultMessage: "Blue (questions errors)",
  },
  legendLabelOmittedQuestion: {
    id: "app.containers.Results.legendLabelOmittedQuestion",
    // defaultMessage: "Amarillo (preguntas omitidas)",
    defaultMessage: "Yellow (ommited questions)",
  },
  legendLabelCanceledQuestion: {
    id: "app.containers.Results.legendLabelCanceledQuestion",
    // defaultMessage: "Amarillo (preguntas omitidas)",
    defaultMessage: "Red (canceled questions)",
  },
  canceled: {
    id: "app.containers.Results.canceled",
    defaultMessage: "canceled",
  }
});
